// src/components/PublicFooter.tsx

import * as React from "react";

import {
  Link,
} from "react-router-dom";

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export function PublicFooter():
React.JSX.Element {
  const currentYear =
    new Date()
      .getFullYear();

  return (
    <footer className="public-footer">
      <div className="public-container public-footer-inner">
        <div className="public-footer-brand">
          <Link
            to="/"
            className="public-footer-wordmark"
            aria-label="Estatly home"
          >
            Estatly
          </Link>

          <p className="public-footer-copyright">
            © {currentYear} Estatly
          </p>
        </div>

        <nav
          className="public-footer-links"
          aria-label="Legal"
        >
          <Link to="/privacy">
            Privacy
          </Link>

          <Link to="/terms">
            Terms
          </Link>
        </nav>
      </div>
    </footer>
  );
}